import { EVENT_TYPES, emit } from '@/utils/event-emitter.js';

export default {
  mounted() {
    setTimeout(() => {
    this.$nextTick(() => {
      const defaultSlots = this.$slots?.default ? this.$slots?.default : [];
      const defaultSlotsMessages = defaultSlots
        .filter((vnode) => vnode.tag !== 'i')
        .map((vnode) => vnode?.elm?.innerHTML || vnode?.elm?.textContent);
      const title = this.title;
      const description = this.description;

      emit(EVENT_TYPES.UI_ALERT, {
        type: this.type,
        message: [title, description, ...defaultSlotsMessages].filter((message) => !!message),
      });
    });
    }, 1000);
  },
};
